module.exports = __webpack_public_path__ + "img/safety.6f64c312.svg";